// extracted by mini-css-extract-plugin
module.exports = {"firstPage":"firstPage_firstPage__MKhSd"};